export default __webpack_public_path__ + "static/9-be9cf9e09e5bf4fc187de77119e8f052.png";